import { useContext } from 'react'
import { SearchContext } from '@mc/algolia-search'

type TSearchContext = {
  query: string
  setQuery(s: string): void
}

export const useSearchContext = () => useContext<TSearchContext>(SearchContext)
